import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import styles from './styles.module.scss';
import imageMetaData from "../../.sourceflow/image_metadata.json";
import md5 from "md5";


export default function ImageTextContent({
    global,
    title,
    image,
    pathPrefix,
    text
}) {
    return (
        <section className={`${styles.root} mb-5 pb-5`}>
            <Container>
                <header className="mb-4">
                    {title}
                </header>
                <figure>
                    <SourceFlowImage
                        src={image ? image : "/site-assets/placeholders/img-placeholder.jpg"}
                        path={`${pathPrefix ? pathPrefix : md5(image)}.image`}
                        imagesMetaData={imageMetaData}
                        size="1000x"
                        alt={"Tackling Climate Change"}
                        className="card-img"
                    />
                </figure>
                <article>
                    {text}
                </article>
            </Container>
        </section>
    )
}